import { CalendarRefreshOutlineIcon } from './CalendarRefreshOutlineIcon';

/**
 * author: Michael Irigoyen
 * id BC0BD74D-06D4-458A-B0CE-90B96A2ADCBF
 * name calendar-refresh-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-refresh-outline.svg
 * tags
 * - Date / Time 
 */
export const CalendarRepeatOutlineIcon = CalendarRefreshOutlineIcon;
export default CalendarRepeatOutlineIcon